// extracted by mini-css-extract-plugin
export default {"features":"Features_features__J3SlK","container":"Features_container__GyNCR"};